const isBrowser = typeof window !== 'undefined';

export const getLocaleCountryCode = (): string | undefined => {
  if (!isBrowser || typeof navigator === 'undefined') return undefined;
  const locales = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const locale of locales) {
    if (!locale) continue;
    const normalized = locale.replace(/_/g, '-').split('-u-')[0].split('-x-')[0];
    const parts = normalized.split('-');
    for (let index = parts.length - 1; index >= 0; index -= 1) {
      const part = parts[index];
      if (/^[A-Za-z]{2}$/.test(part) || /^\d{3}$/.test(part)) {
        return part.toUpperCase();
      }
    }
  }
  return undefined;
};
